module.exports = __webpack_public_path__ + "static/media/carbody-2.27d87a4a.png";